

export const QUERY_SETUP_STEP = ["1 min", "15 min", "1h", "1D", "1M", "1Y"]

export const UNIT = ['MWh', 'MW', 'kW', 'eur/MWh', 'kWh']

